// extracted by mini-css-extract-plugin
module.exports = {"resource_list":"VetResources_resource_list__99Mb5","item":"VetResources_item__irKsq"};